import { render, staticRenderFns } from "./LeadsList.vue?vue&type=template&id=536665f0"
import script from "./LeadsList.vue?vue&type=script&lang=js"
export * from "./LeadsList.vue?vue&type=script&lang=js"
import style0 from "./LeadsList.vue?vue&type=style&index=0&id=536665f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports